import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { CollapseState } from '@recruitee/common';

import { SidebarInternalService } from './sidebar-internal.service';

export const collapseHorizontal = trigger('collapseHorizontal', [
  state(
    'collapsed',
    style({
      width: '48px',
      minWidth: '48px',
    }),
  ),
  state(
    'normal',
    style({
      width: '*',
      minWidth: '*',
    }),
  ),
  // immediate change state from none state to collapsed
  transition('void <=> collapsed', animate('0ms')),
  transition('* <=> collapsed', animate('200ms ease-in-out')),
  transition('collapsed <=> normal', animate('200ms ease-in-out')),
]);

@Component({
  selector: 'rt-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  providers: [SidebarInternalService],
  animations: [collapseHorizontal],
})
export class SidebarComponent implements OnInit {
  @Input() public hasExpander: boolean = true;
  @Input() public isExpanded: boolean = true;
  @Input() public size: 'default' | 'large' = 'default';

  @Output() public expanded: EventEmitter<boolean> = new EventEmitter();
  @Output() public animationEvent: EventEmitter<AnimationEvent> = new EventEmitter();

  public isMinimized: boolean;

  constructor(
    private cdRef: ChangeDetectorRef,
    private sidebarInternalService: SidebarInternalService,
  ) {}

  public ngOnInit(): void {
    this.isMinimized = !this.isExpanded;
    this.sidebarInternalService.sidebarMinimized.next(this.isMinimized);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isExpanded?.currentValue) {
      this.isMinimized = !this.isExpanded;
      this.sidebarInternalService.sidebarMinimized.next(this.isMinimized);
    }
  }

  public get collapseState(): CollapseState {
    return this.isMinimized ? CollapseState.Collapsed : CollapseState.Normal;
  }

  public onExpanderClick(): void {
    this.isMinimized = !this.isMinimized;
    this.sidebarInternalService.sidebarMinimized.next(this.isMinimized);
    this.expanded.emit(!this.isMinimized);
    this.cdRef.detectChanges();
  }
}
